
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/kredit-hp",
      function () {
        return require("private-next-pages/kredit-hp.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/kredit-hp"])
      });
    }
  